module.exports = __webpack_public_path__ + "img/Shopifylogo.d3eaa76d.svg";